import { Badge, Button, Icon, IconName } from '@optimus-web/core';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { showReservationDetail } from '../../../routes';
import { ProductCheckListDataTestIds } from '../../constants';
import { ReservationTab } from '../../../../types/reservationTab';

interface NotesCellProps {
    count: number;
    reservationId: string | undefined;
}

export const NotesCell: React.FC<NotesCellProps> = ({ count, reservationId }) => {
    const dispatch = useCommanderThunkDispatch();

    if (!count) {
        return null;
    }

    const openReservation = () => {
        if (reservationId) {
            dispatch(showReservationDetail({ reservationId, reservationTab: ReservationTab.Properties }));
        }
    };

    return (
        <span data-test-id={ProductCheckListDataTestIds.cellNotes}>
            <Button onClick={openReservation} disabled={!reservationId} variant="ghost" type="submit">
                <Badge content={count}>
                    <Icon value={IconName.Notes} size="small" />
                </Badge>
            </Button>
        </span>
    );
};
